import {
  THEME_STORAGE_KEY,
  type ThemePreference,
} from '@crisp/ui-toolkit';

const LEGACY_STORAGE_KEY = 'crisp_theme';

function isThemePreference(value: string | null): value is ThemePreference {
  return value === 'light' || value === 'dark' || value === 'system';
}

/**
 * The docs header used to persist `crisp_theme` and toggle `html.dark`.
 * Cabbage / ui-toolkit read `crisp:theme` and write `data-theme="crisp-*"`.
 * Copy the old key once so existing readers keep their choice.
 */
export function migrateLegacyThemePreference(): void {
  try {
    if (localStorage.getItem(THEME_STORAGE_KEY)) return;
    const legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
    if (isThemePreference(legacy)) {
      localStorage.setItem(THEME_STORAGE_KEY, legacy);
    }
  } catch {
    // Private mode / blocked storage — theme init falls back to its default.
  }
}
